import React, { forwardRef } from 'react';
import { Typography, Box } from '@mui/material';
import { useFormikContext } from 'formik';
import { IProfession } from '../createEditProfile/formFragments/constants';
import FormProfessions from '../createEditProfile/formFragments/professions';

const Professions = forwardRef<{ mergePendingItems: () => IProfession[] }, {}>((props, ref) => {
  const { values, setFieldValue } = useFormikContext<{ professions: IProfession[] }>();

  const updateProfessions = (newProfessions: IProfession[]) => {
    setFieldValue('professions', newProfessions);
  };

  const currentProfessions = values.professions || [];

  return (
    <Box key="professions" className="pt-4">
      <Typography
        variant="h4"
        sx={{
          color: 'var(--Base-1000, #000)',
          fontSize: '24px',
          fontStyle: 'normal',
          fontWeight: 900,
          lineHeight: '132%',
        }}
      >
        Professions
      </Typography>
      <hr style={{ color: 'var(--border)', marginTop: '16px' }} />

      <Box className="flex flex-col gap-2 w-full pt-3 pb-6">
        <FormProfessions
          ref={ref}
          professions={currentProfessions}
          updateProfessions={updateProfessions}
          inputProps={{ sx: { border: 0, px: 0 } }}
          isApplicationForm={true}
        />
      </Box>
    </Box>
  );
});

Professions.displayName = 'Professions';

export default Professions;
